// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__2s0_5","title":"ClientReferral_title__1ysQO","itemText":"ClientReferral_itemText__1Oroa"};